import * as React from 'react'

export default function DashboardPage() {
  return (
    <div className="flex h-screen flex-col justify-center text-center text-slate-500">
      Not Implemented
    </div>
  )
}
